import FrontPage from '../components/frontPage';
import HeroSwipper from '../components/hero';

export default {
  init() {
    new FrontPage();
    new HeroSwipper();
    AOS.init(); // eslint-disable-line

    if($('.back-top__wrapper').length) {
      $('.back-top__wrapper').on('click', () => {
        window.scrollTo({ top: 0, behavior: 'auto' })
        if(window.location.hash) window.location.hash = '';
      });
    }

    $('.scroll-buttton').on('click', () => {
      let menuHeight;
      if($(window).width() > 992) {
        menuHeight = $('.header__main-nav').height() + 45;
      } else {
        menuHeight = $('.header--mobile__main-nav').height();
      }
      $('html, body').animate({
        scrollTop: $('#offices').offset().top - menuHeight,
      }, 50, 'linear');
    });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js